import { z } from "zod";
import { ERROR_CODE_LIST } from "../errors/codes.js";
import { Timestamp } from "./time.js";
/** application/problem+json body for every error response (contracts section 2). */
export const Problem = z
    .object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    code: z.enum(ERROR_CODE_LIST),
    detail: z.string().optional(),
    traceId: z.string(),
    errors: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
    signedInAt: Timestamp.optional().describe("With `SIGNED_IN_ELSEWHERE`: when the account was signed in on the device that took over (ADR 0030)"),
})
    .meta({ id: "Problem" });
//# sourceMappingURL=problem.js.map